/**
 * Auto Logout
 */

// LIVE CONFIGURATION
const autoLogoutDelay = 60; // seconds
const serverSessionTimeoutInMinutes = window.GLOBAL.SESSION_TIMEOUT;

// TESTING CONFIGURATION
// const autoLogoutDelay = 30; // seconds
// const serverSessionTimeoutInMinutes = 1;

const logoutUrl = window.GLOBAL.SESSION_LOGOUT_URL;
const modalDomId = 'timeout';

export default class AutoLogout {
    constructor() {
        document.addEventListener('DOMContentLoaded', this._init.bind(this));
    }

    logout() {
        window.location.href = logoutUrl;
    }

    showLogoutWarning() {
        window.location.hash = `#${modalDomId}`;
    }

    _init() {
        if (!document.getElementById(modalDomId) ||
            typeof (serverSessionTimeoutInMinutes) !== 'number' ||
            serverSessionTimeoutInMinutes < 0) {
            return;
        }

        const serverSessionTimeout = serverSessionTimeoutInMinutes * 60; // seconds
        const showMessageDelay = serverSessionTimeout - autoLogoutDelay; // seconds

        window.setTimeout(this.showLogoutWarning.bind(this), showMessageDelay * 1000);
        window.setTimeout(this.logout.bind(this), serverSessionTimeout * 1000);
    }
}
